<div class="banner">
  <div class="participant participant-1">
    <div class="name">{{ odds?.participants?.['1']?.name }}</div>
    <div class="odd" [ngClass]="{locked: odds?.opportunities?.['1']?.active === false}">
      <ng-container *ngIf="odds?.opportunities?.['1']?.active !== false">{{ odds?.opportunities?.['1']?.odd }}</ng-container>
    </div>
  </div>
  <div class="participant participant-2">
    <div class="name">{{ odds?.participants?.['2']?.name }}</div>
    <div class="odd" [ngClass]="{locked: odds?.opportunities?.['2']?.active === false}">
      <ng-container *ngIf="odds?.opportunities?.['2']?.active !== false">{{ odds?.opportunities?.['2']?.odd }}</ng-container>
    </div>
  </div>
</div>
